import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, ref, shallowRef, watch } from "vue"

import { getFullImagePath } from "@/utils/cdn"
import imageUrlWrapper from "@/utils/imageUrlWrapper"

type Props = {
  images?: Array<string>
  hideCount?: boolean
  size?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Thumbnail',
  props: {
    images: { default: () => [] },
    hideCount: { type: Boolean, default: false },
    size: { default: 65 }
  },
  setup(__props: any) {

const props = __props as { images: Array<string>, hideCount: boolean, size: number };



const thumbnailSize = shallowRef("300x300")

const showGallery = inject<Function>("showGallery")

const mainImage = ref()

const thumbnailImageUrl = computed<string>(() => {
  if (hasImages.value) {
    const firstImage = props.images[0]
    const isNotCdn = firstImage.includes("://")

    return isNotCdn ? firstImage : getFullImagePath(firstImage, thumbnailSize.value)
  }

  return imageUrlWrapper(null)
})
const length = computed<number>(() => props.images.length)
const hasImages = computed<boolean>(() => Boolean(length.value))

watch(thumbnailImageUrl, (newUrl) => {
  if (mainImage.value?.src && mainImage.value.src !== newUrl) {
    mainImage.value.src = newUrl
  }
})

const sizes = computed(() => {
  return {
    width: `${props.size}px`,
    height: `${props.size}px`,
    minWidth: `${props.size}px`,
    minHeight: `${props.size}px`,
    display: "inline-block"
  }
})

const openGallery = () => {
  if (hasImages.value && showGallery) {
    showGallery({
      images: props.images
    })
  }
}
const handleError = () => {
  thumbnailSize.value = "full"
}

return { __sfc: true,props, thumbnailSize, showGallery, mainImage, thumbnailImageUrl, length, hasImages, sizes, openGallery, handleError }
}

})